import {
  Getters,
  Mutations,
  Actions,
  Module,
  createMapper,
} from 'vuex-smart-module';

class CurrencyState {
  count = 1
}

class CurrencyGetters extends Getters<CurrencyState> {
  get double() {
    return this.state.count * 2;
  }

  get triple() {
    return this.getters.double + this.state.count;
  }
}

class CurrencyMutations extends Mutations<CurrencyState> {
  increment(payload: number) {
    this.state.count += payload;
  }
}

class CurrencyActions extends Actions<
  CurrencyState,
  CurrencyGetters,
  CurrencyMutations,
  CurrencyActions
> {
  incrementAsync(payload: { amount: number; interval: number }) {
    return new Promise(() => {
      setTimeout(() => {
        this.commit('increment', payload.amount);
      }, payload.interval);
    });
  }
}

// Экспорт модуля
export const CurrencyModule = new Module({
  state: CurrencyState,
  getters: CurrencyGetters,
  mutations: CurrencyMutations,
  actions: CurrencyActions,
});

export const CurrencyModuleMapper = createMapper(CurrencyModule);
